var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"silentbox-item",attrs:{"src":_vm.src},on:{"click":_vm.openSilentBoxOverlay}},[_vm._t("default",[_c('img',{attrs:{"src":_vm.getThumnail(_vm.src),"width":_vm.thumbnailWidth,"height":_vm.thumbnailHeight}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }